'use client'

import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { Box, Button, Container, Grid, Stack, Typography } from '@mui/material'
import Image from 'next/image'
import { ReactElement } from 'react'

export const OpenNowSection = (): ReactElement => {
	return (
		<Box
			sx={{
				py: 8,
				px: { xs: 2, md: 8, lg: 16 },
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				gap: '100px'
			}}>
			<Container maxWidth='lg' className='my-14'>
				<Grid container spacing={{ xs: 2, md: 4 }} alignItems='center'>
					<Grid
						size={{
							xs: 12,
							md: 5
						}}>
						<Box>
							<Image src='/assets/images/open-store-now.svg' alt='open-store-now' width={559} height={0} style={{ height: 'auto' }} />
						</Box>
					</Grid>
					<Grid
						size={{
							xs: 12,
							md: 7
						}}>
						<Stack spacing={3.75}>
							<Typography variant='h4' className='font-bold'>
								Jualan Online Lebih Mudah di UMKMs!
							</Typography>

							<Typography
								variant='body1'
								sx={{
									fontWeight: 500,
									color: '#000000',
									fontSize: '32px'
								}}
								className='font-medium text-xl'>
								Upload produk dan mulai promosikan bisnismu sekarang.
							</Typography>

							<Box>
								<Button
									variant='contained'
									color='primary'
									size='large'
									className='font-bold text-md p-5'
									endIcon={<ArrowForwardIcon />}
									href='https://play.google.com/store/apps/details?id=com.umkmpintar.umkms'
									target='_blank'
									rel='noopener noreferrer'>
									Buka Toko Sekarang
								</Button>
							</Box>
						</Stack>
					</Grid>
				</Grid>
			</Container>
		</Box>
	)
}
